// Topbar.tsx — Brand + signed-in user email + sign-out.

import { useAuth } from '@/services/useAuth';

export function Topbar() {
  const { user, signOut } = useAuth();
  return (
    <header className="console-topbar">
      <a href="#/license-orgs" className="console-brand">
        <img
          src="/images/app-icon.png"
          alt="SocialMesh"
          className="console-brand-img"
        />
        <span className="console-brand-text">SocialMesh Console</span>
      </a>
      <div className="console-user">
        <span className="console-user-email">
          {user?.email ?? 'Signed in'}
        </span>
        <button
          className="console-btn console-btn-ghost"
          type="button"
          onClick={() => {
            signOut();
          }}
        >
          <span className="material-icons">logout</span> Sign out
        </button>
      </div>
    </header>
  );
}
